import { Box, Spinner } from "@chakra-ui/react";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";

const Backdrop = ({ display = true }: { display?: boolean }): JSX.Element => {
  const runningAPICount = useIsFetching();
  const mutatingAPICount = useIsMutating();
  return (
    <>
      {(runningAPICount > 0 || mutatingAPICount > 0) && display && (
        <Box
          width="100vw"
          minH="100vh"
          className="backdrop-opacity-10 fixed top-0  flex justify-center items-center z-10"
          background="#00000029"
          pointerEvents="none"
        >
          <Spinner color="##0080806e" thickness="5px" size="xl" speed="0.65s" />
        </Box>
      )}
    </>
  );
};

export default Backdrop;
